import React from 'react';

const CustomAction: React.FC<{}> = () => {
    return (
        <h1>Custom component</h1>
    )
}

export default CustomAction;
